import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Bottom-Nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, { mode: "horizontal" }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, { to: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, null, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "el-icon-s-home" }, null, -1),
                _createElementVNode("span", null, "Home", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/opportunities/matched" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, null, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "el-icon-search" }, null, -1),
                _createElementVNode("span", null, "Matched", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/biddings?status=ongoing" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, null, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "el-icon-document" }, null, -1),
                _createElementVNode("span", null, "Bids", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("span", null, [
          _createVNode(_component_el_dropdown, null, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/account/profile" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        divided: _ctx.user.type === 'founder',
                        icon: "el-icon-user"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode(" Account Profile ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["divided"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/account/settings" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { icon: "el-icon-setting" }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(" Account Settings ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, [
                    _createVNode(_component_el_dropdown_item, {
                      divided: "",
                      icon: "el-icon-right"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode(" Logout ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "el-icon-user" }, null, -1),
                  _createElementVNode("span", null, "Account", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}